module.exports = __webpack_public_path__ + "da7d5192542122852615ecb32470ae4b.glb";